import { DateTime } from 'luxon';
import { defaultDisplayDateFormat } from '../constants';

const formatDisplayDate = (dateString: string, includeYear = false) => {
  const dateTime = DateTime.fromISO(dateString);

  const currentYear = DateTime.now().year;

  if (dateTime.year === currentYear && !includeYear) {
    return dateTime.toFormat('MMM d');
  } else {
    return dateTime.toFormat(defaultDisplayDateFormat);
  }
};

export default formatDisplayDate;
